<template>
<v-form ref="form" v-model="valid">
  <v-container fluid>
    <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
    </v-app-bar>
  </nav>

    <v-card-title>General</v-card-title>
    <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>Air Quality Console S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="serialNumber"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="airQualitySn"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Air Quality Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="airQualityConsole"> </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
        <v-subheader>Location Name</v-subheader>
        </v-col>
      <v-col cols="2">
           <v-select  
            :items="locationItem"
            item-value="_id"
            :item-text="
            (locationItem) => {
            return (locationItem.location);
            }"
            v-model="location"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>Console Power Source</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="boardName"> </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>Installation Method</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="installMethod"> </v-text-field>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Remarks</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="locationRemarks"> </v-text-field>
        </v-col>
      </v-row>
   </v-card>

     <v-btn fixed dark fab bottom right color="blue" @click="saveItem()">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
  </v-container>
</v-form>
</template>


<script>
import axios from "axios";
import router from "../../router";

export default {
  data() {
    return {
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Settings',
          disabled: true,
          href: '',
        },
        {
          text: 'Air Quality',
          disabled: false,
          href: '/air-quality',
        },
        {
          text: 'Add',
          disabled: true,
          href: '',
        }
      ],
    airQualitySn: "",
    airQualityConsole: "",
    boardName: "",
    location: "",
    installMethod: "",
    locationRemarks: "",
    modifiedBy: "",

    valid: true,
    serialNumber: [],
    locationItem: [], 
    showDeleteDialog: false,
    };
  },
  created(){
      this.loadsSerialNumber();
      this.loadsLocation();
  },
  methods: {
    loadsLocation: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/location";
    axios.get(apiURL).then(res => {
    this.locationItem = res.data;
    }).catch(error => {
        console.log(error)
    });
  },
    loadsSerialNumber: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/serial-number-aq";
    axios.get(apiURL).then(res => {
    this.serialNumber = res.data;
    }).catch(error => {
        console.log(error)
    });
  },
    async saveItem() {
      if (this.$refs.form.validate()) {
      let apiURL = process.env.VUE_APP_API + "/api/create-air-quality";
      axios
        .post(
      apiURL,
          {
    airQualitySn: this.airQualitySn,
    airQualityConsole: this.airQualityConsole,
    boardName: this.boardName,
    location: this.location,
    installMethod: this.installMethod,
    locationRemarks: this.locationRemarks,

    modifiedBy: this.$keycloak.tokenParsed.given_name
          });
    }
     router.go(-1);
      }
    }
  };
</script>